import { AppApiAction } from 'actions/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import requestGetAccountBusiness from 'businessTraveller/requests/requestGetAccountBusiness'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'businessTraveller/reducers/businessTravellerApiActionReducers'

interface Params {
  refetch?: boolean
}

export function fetchAccountBusiness(params?: Params): AppApiAction {
  return (dispatch, getState) => {
    const state = getState()

    if (!state.businessTraveller.currentBusinessAccount || params?.refetch) {
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_ACCOUNT_BUSINESS,
        request: () => requestGetAccountBusiness(state.auth.accessToken),
      })
    }
  }
}

export default fetchAccountBusiness
